import React from "react";

import Lamina22mapa from "../images/lamina22mapa.png";
import Lamina22actividad from "../images/lamina22actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina22 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 22: Las lenguas del Perú"
        meta={[
          {
            property: "og:title",
            content: "Lámina 22: Las lenguas del Perú",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "El Perú es un país multilingüe en el que se hablan muchos idiomas.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="22" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="Las lenguas del Perú" color="green" size="lg" />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="flex-start"
          justify="center"
        >
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <p>
              El Perú es un país multilingüe en el que se hablan muchos idiomas,
              como el castellano, el quechua, el aimara, el asháninka, el
              awajún, el shipibo-konibo y otros más, en diferentes partes del
              territorio. Se han identificado casi 50 lenguas originarias en
              todo el país, la mayoría de ellas son habladas en los Andes y la
              Amazonía.
            </p>
            <br></br>
            <Actividad color="green" />
            <p>
              <strong>Observa el mapa del Perú. </strong>Cada color representa
              una lengua.
            </p>
            <p>
              Con ayuda de un familiar, ubica en el mapa la región donde vives y
              responde:
            </p>
            <ul>
              <li>¿Qué lenguas originarias se hablan en ella?</li>
              <li>¿Tú o algún familiar habla esa lengua?</li>
              <li>¿En qué espacios lo hacen?</li>
            </ul>
            <p style={{ color: "#6a2c91" }}>
              <strong>
                La mayoría se encuentra en la selva. Algunas de ellas también se
                hablan en Brasil, Bolivia y Colombia.
              </strong>
            </p>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <img src={Lamina22mapa} alt="Mapa" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>
          El idioma español o castellano fue traído a nuestro territorio por los
          españoles hace cinco siglos. Cuando esto pasó ya se hablaban más de
          doscientas lenguas en nuestro territorio, como el quechua, el aimara o
          el muchik. Poco a poco el castellano se convirtió en la lengua más
          hablada y las lenguas originarias fueron relegadas. Algunas
          desaparecieron, otras subsistieron y otras se fusionaron con el nuevo
          idioma. Por eso, muchas de las palabras que usamos como español del
          Perú provienen de lenguas originarias, sobre todo del quechua; tal es
          el caso, por ejemplo, de las palabras{" "}
          <span style={{ color: "rgb(236, 0, 140)", fontWeight: 700 }}>
            guano, llama, chacra, choclo, coca, calato.
          </span>
        </p>

        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Actividad color="green" />
            <p>
              <strong>
                Completa el siguiente crucigrama con palabras prestadas del
                quechua al español mencionadas antes y que correspondan a las
                siguientes definiciones:
              </strong>
            </p>
            <ol>
              <li>Abono hecho de excremento de aves.</li>
              <li>
                Mamífero de los Andes domesticado y usado como animal de carga.
              </li>
              <li>Terreno para el cultivo.</li>
              <li>Mazorca de maíz tierno.</li>
              <li>
                Planta cuyas hojas se mastican en zonas de altura para tener
                energía.
              </li>
              <li>Desnudo, sin ropa.</li>
            </ol>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina22actividad} alt="Actividad" />
          </Grid>
        </Grid>
        <p style={{ color: "#00aeef" }}>
          <strong>
            Si bien el castellano es la lengua más extendida en el país, no
            todos hablamos de la misma manera. Por ejemplo, el que se habla en
            Piura no es igual al que se usa en Arequipa.
          </strong>
        </p>
        <p style={{ color: "#00aeef" }}>
          <strong>
            El castellano adquirió muchas variantes por influencia de las
            lenguas originarias, tanto en su pronunciación como en su
            entonación. Por eso, existe un castellano andino, que tiene la
            influencia quechua y aimara, o un castellano amazónico, que tiene
            influencia awajún y shawi. Estas variantes se han dado a causa de la
            migración. Estas y otras variantes son válidas y no deben ser motivo
            de ningún tipo de discriminación.
          </strong>
        </p>
        <p>
          <strong>Responde:</strong> ¿Qué variantes del castellano crees que hay
          en tu zona?
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-22.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 22: Las lenguas del Perú'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Las migraciones"
        anteriorEnlace="/lamina-1-21"
        siguiente="La importancia de cuidar nuestras lenguas"
        siguienteEnlace="/lamina-1-23"
      />
    </>
  );
};

export default Lamina22;
